import { render, staticRenderFns } from "./TK010TeikiDetailParts.vue?vue&type=template&id=29a8f00a&"
import script from "./TK010TeikiDetailParts.vue?vue&type=script&lang=js&"
export * from "./TK010TeikiDetailParts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports